import { useEffect, useMemo, useState } from 'react';
import {  useParams } from 'react-router-dom';
import { Card, CardContent, Grid, Typography, Link, Button, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { deleteIcon, hasJiraIcon, scheduledBatchCompareIcon, scheduledBatchExportIcon } from '../assets';
import { Modal} from '../ui';
import { useSelector } from 'react-redux';
import { getCurrentProject, getCurrentTestResultDetails } from '../store/selectors/project.selector';
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { useAppDispatch } from '../store/hooks';
import { setCurrentProjectId, setCurrentProject, setCurrentTestResultDetails } from '../store/resuders/project.reducer';
import { SearchInput } from '../ui';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useNavigate } from "react-router-dom";
import { getProjectById } from '../services/project.service';
import { deleteSelectedBatches, getBatchList, getRecentBatchList, getScheduleList } from '../services/scheduler.service';
import { testRunStop } from '../services/testresults.service';
import { SchedulerGrid } from '../ui/schedulerGrid.ui';
import dayjs from 'dayjs';
import { formatTimestamp } from '../helpers/date.helper';
import { toggleAlert } from '../store/resuders/app.reducer';
import { useTranslation } from 'react-i18next';
import { CHANNELS, CONFIGNAME } from "../types/global.enum";
import { BatchDetails } from '../ui/scheduledTestResult/batchDetails';
import { CompareBatches } from '../ui/scheduledTestResult/compareBatches';
import { uniqueId } from '../helpers/form.helper';
import { TestResultDetails } from './testResultsDetails';
import { appConfigSelector } from '../store/selectors/app.selector';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { JiraTicket } from './jira/jira.component';
import { getTestResultDetails, getexportlogFile, getLensLogFile } from '../services/testresults.service';
import BlockIcon from '@mui/icons-material/Block';
import { exportToFile } from '../helpers/exportToFile.helper';

export const ScheduledTestResults = () => {
    const { projectId, scheduledId, testResultId } = useParams();
    const [isOpen, setIsOpen] = useState<string>('');
    const { t } = useTranslation();
    const project = useSelector(getCurrentProject);  // Store Project
    const [schedulerPage, setSchedulerPage] = useState(true);
    const [scheduledBatchPage, setScheduledBatchPage] = useState(false);
    const [scheduledBatchDetailsPage, setScheduledBatchDetailsPage] = useState(false);
    const [scheduledTestResultDetailsPage, setScheduledTestResultDetailsPage] = useState(false);
    const [openCompareBatch, setOpenCompareBatch] = useState('');
    const currentDate: any = dayjs();
    const oneWeekAgoDate: any = currentDate.subtract(7,'Day');
    const [startDateFilter, setStartDateFilter] = useState<any>(oneWeekAgoDate);
    const [stopDateFilter, setStopDateFilter] = useState<any>(currentDate);
    const [selectedScheduler, setSelectedScheduler] = useState<any>();
    const testResultDetails = useSelector(getCurrentTestResultDetails);
    const appConfig = useSelector(appConfigSelector);
    const [openJiraModal, setOpenJiraModal] = useState<string>('');

    const dispatch = useAppDispatch();
    const history = useNavigate();
    const [data, setData] = useState<any>([]);
    const [defaultSelected, setDefaultSelected] = useState<string>('');
    const [batchList, setBatchList] = useState<any>([]);
    const [totalPages, settotalPages] = useState(1);
    const [selectedBatch, setSelectedBatch] = useState<any>();
    const [selectedBatchIds, setSelectedBatchIds] = useState<any>([]);
    const [batchSource, setBatchSource] = useState<'recent' | 'all'>('recent');
    const [batchSourceNotice, setBatchSourceNotice] = useState<string>('');
    const [SchedulerPageNo , setSchedulerPageNo] = useState<any>(0);
    const [ScheduledBatchPageNo, setScheduledBatchPageNo] = useState<number>(0);
    const [criteria, setCriteria] = useState<any>({
        sort: '-lastModifiedTime',
        pageNo: 0,
        pageSize: 20,
        schedulerPageNo:0, // For Scheduler Page
        scheduledBatchPageNo:0, // For Scheduled Batch Page
        filter: localStorage.getItem('SchedulesFilter') ? localStorage.getItem('SchedulesFilter') : '',
        projectId: project ? project?.testProjectID : projectId
    });
    const hasJiraEnabled = useMemo(()=>appConfig?.some(c=>c.configName === CONFIGNAME.JIRA && c.configValue) ,[appConfig])
    const toNumber = (value: unknown): number | undefined => {
        if (value === null || value === undefined) {
            return undefined;
        }

        const parsed = Number(value);
        return Number.isNaN(parsed) ? undefined : parsed;
    };
    const pageSizeChanged = (size: number) => {
        setCriteria({
            ...criteria,
            pageSize: size,
        })
    }

    const onStartDateChanged = (startDate: any) => {
        if(!startDate){
            setStartDateFilter(null);
            return;
        }
        if (typeof startDate === 'object') setStartDateFilter(startDate);
    }

    const onStopDateChanged = (stopDate: any) => {
        if(!stopDate){
            setStopDateFilter(null);
            return;
        }

        if (stopDate) setStopDateFilter(stopDate);
    }

    const schedulerColumns: any[] = [
        {
            fieldName: 'testScheduleId', caption: t('ID'), width: '5%', sortable: true,
            redner: (params: any) => (
                <div className="flex-center">
                    <Link className="a-link-black" onClick = {ScheduleBatchPage(params)}>
                        {params.testScheduleId}
                    </Link>
                </div>
            )
        },
        {
            fieldName: 'name', caption: t('SCHEDULE NAME'), width: '35%', sortable: true,
            redner: (params: any) => (
                <div className="flex-center">
                    <Link className="a-link-black" onClick = {ScheduleBatchPage(params)}>
                        {params.name}
                    </Link>
                </div>
            )
        },
        {
            fieldName: 'lastRunTime', caption: t('LAST RUN DATE'),width: scheduledBatchDetailsPage ? '45%' : '15%', sortable: true,
            redner: (params: any) => (
                <div className="flex-center">
                    {params.lastRunTime ? formatTimestamp(params.lastRunTime) : t('No Last Run')}
                </div>

            )
        },
        {
            fieldName: 'lastRunStatus', caption: t('LAST RUN STATUS'), width: scheduledBatchDetailsPage ? '45%' : '20%',
            redner: (params: any) => {
                // const _totalRun = (params.lastRunStatus?.success || 0)+(params.lastRunStatus?.warning|| 0)+(params.lastRunStatus?.fail || 0);
                const _totalRun = (params.lastRunStatus?.total || 0);
                const s = ((params.lastRunStatus?.success || 0)/_totalRun) * 100;
                const r = ((params.lastRunStatus?.running || 0)/_totalRun) * 100;
                const f = ((params.lastRunStatus?.fail || 0)/_totalRun) * 100;
                const st = ((params.lastRunStatus?.forceStopped || 0)/_totalRun) * 100;
                const to = ((params.lastRunStatus?.timeoutStopped || 0)/_totalRun) * 100;
                const progress = (params.lastRunStatus?.success || 0)+(params.lastRunStatus?.warning|| 0)+(params.lastRunStatus?.fail || 0)+(params.lastRunStatus?.forceStopped || 0)+(params.lastRunStatus?.timeoutStopped || 0);

                return (
                <div className="flex-center">
                    {params.lastRunStatus ?
                        (progress === _totalRun ?
                            <>
                            <div className='bar-container'>
                            <div className='bar-success' title={`${s.toFixed(0)}%`} style={{width:`${s}%`}}></div>
                            <div className='bar-running' title={`${r.toFixed(0)}%`}  style={{width:`${r}%`}}></div>
                            <div className='bar-fail' title={`${f.toFixed(0)}%`}  style={{width:`${f}%`}}></div>
                            <div className='bar-forceStopped' title={`${st.toFixed(0)}%`}  style={{width:`${st}%`}}></div>
                            <div className='bar-timeoutStopped' title={`${to.toFixed(0)}%`}  style={{width:`${to}%`}}></div>
                            </div>
                            <div>
                            { params.lastRunStatus?.forceStopped !== 0 && (
                                <span>
                                    <BlockIcon  className='forcestop_blockicon' /> 
                                </span>
                            )}
                            { params.lastRunStatus?.timeoutStopped !== 0 && (
                                <span>
                                    <BlockIcon  className='timeout_blockicon' /> 
                                </span>
                            )} 
                            Total: {_totalRun}
                        </div>
                            {/* <div>{params.lastRunStatus?.forceStopped || params.lastRunStatus?.timeoutStopped !== 0 && ( <BlockIcon style={{ color: "red", fontSize: "24px" }} />
                            )}{" "} Total: {_totalRun}</div> */}
                            </>
                            :
                            <>
                            <div className='flex-center w-100' style={{justifyContent: 'space-around'}}>
                            <div>
                            { params.lastRunStatus?.forceStopped !== 0 && (
                                <span>
                                    <BlockIcon  className='forcestop_blockicon' /> 
                                </span>
                            )}
                            {params.lastRunStatus?.timeoutStopped !== 0 && (
                                <span>
                                    <BlockIcon  className='timeout_blockicon' /> 
                                </span>
                            )}
                            Total: {_totalRun}
                        </div>
                            {/* <div>
                                {params.lastRunStatus?.forceStopped || params.lastRunStatus?.timeoutStopped !== 0 ? t("Stopped") : t("Running")}
                            </div> */}
                            {params?.lastRunStatus.running !== 0 && (
                                <div><Typography fontWeight={600}>Progress: {progress} / {_totalRun}</Typography></div>
                            )}
                                </div>
                            </>)
                    :
                        <div>
                         No Run status
                        </div>
                    }                    
                </div>
            )}
        },
        !scheduledBatchDetailsPage &&{
            fieldName: 'type', caption: t('SCHEDULE TYPE'), sortable: true, width: '20%'
        }
    ];

    // Columns for Test Results Status Page
    const schedulerBatchColumns: any[] = [
        !selectedBatch && {
            fieldName: 'archiveId', caption: t('ID'), width: '10%', key: true, sortable: true,
            redner: (params: any) => (
                <div className="flex-center">
                    <Link className="a-link-black" onClick = {openBatchDetailsView(params)}>
                        {params.archiveId}
                    </Link>
                </div>
            )
        },
        !selectedBatch && {
            fieldName: 'scheduleName', caption: t('SCHEDULE NAME'), width: '30%',
            redner: (params: any) => (
                <div className="flex-center">
                    <Link className="a-link-black" onClick = {openBatchDetailsView(params)}>
                        {params.scheduleName}
                    </Link>
                </div>
            )
        },
        {
            fieldName: 'runStartDate', caption: t('RUN DATE'),width: selectedBatch ? '45%' : '15%', sortable: true,
            redner: (params: any) => (
                <div className="flex-center">
                    {params.runStartDate ? formatTimestamp(params.runStartDate) : t('No Run Date')}
                </div>

            )
        },
        {
            fieldName: 'lastRunStatus', caption: t('LAST RUN STATUS'), width: selectedBatch ? '45%' : '20%',
            redner: (params: any) => {
                // const _totalRun = (params?.success || 0)+(params?.running || 0)+(params?.failed || 0);
                const _totalRun = (params?.total || 0);
                const s = ((params?.success || 0)/_totalRun) * 100;
                const r = ((params?.warning || 0)/_totalRun) * 100;
                const f = ((params?.failed || 0)/_totalRun) * 100;
                const st = ((params?.forceStopped || 0)/_totalRun) * 100;
                const to = ((params?.timeoutStopped || 0)/_totalRun) * 100;

                const progress = (params?.success || 0)+(params?.warning|| 0)+(params?.failed || 0)+(params?.forceStopped || 0)+(params?.timeoutStopped || 0);

                return (
                <div className="flex-center">
                    
                    {progress === _totalRun ?
                    <>
                    <div className='bar-container'>
                    <div className='bar-success' title={`${s.toFixed(0)}%`} style={{width:`${s}%`}}></div>
                    <div className='bar-running' title={`${r.toFixed(0)}%`}  style={{width:`${r}%`}}></div>
                    <div className='bar-fail' title={`${f.toFixed(0)}%`}  style={{width:`${f}%`}}></div>
                    <div className='bar-forceStopped' title={`${st.toFixed(0)}%`}  style={{width:`${st}%`}}></div>
                    <div className='bar-timeoutStopped' title={`${to.toFixed(0)}%`}  style={{width:`${to}%`}}></div>
                    </div>
                    <div>
                        
                        {params?.forceStopped !== 0 && (
                            <span>
                                <BlockIcon  className='forcestop_blockicon'  /> 
                            </span>
                        )}
                        {params?.timeoutStopped !== 0 && (
                            <span>
                                <BlockIcon  className='timeout_blockicon'  /> 
                            </span>
                        )}
                        Total: {_totalRun}
                    </div>
                    </>
                    :
                    <>
                    <div className='flex-center w-100' style={{justifyContent: 'space-around'}}>
                        <div>

                            {params?.forceStopped !== 0 && (
                                <span>
                                    <BlockIcon  className='forcestop_blockicon' /> 
                                </span>
                            )}
                            {params?.timeoutStopped !== 0 && (
                                <span>
                                    <BlockIcon  className='timeout_blockicon' />
                                </span>
                            )}
                            Total: {_totalRun}
                        </div>

                        {/* <div>
                            {params?.forceStopped && params?.forceStopped !== 0 ? t("Stopped") : t("Running")}
                        </div> */}
                        {params?.running !== 0 && (
                        <div><Typography fontWeight={600}>Progress: {progress} / {_totalRun}</Typography></div>
                        )}
                    </div>
                    </>
                    }
                    
                </div>
            )}
        },
        !selectedBatch &&{
            fieldName: 'scheduleType', caption: t('SCHEDULE TYPE'), sortable: true, width: '20%'
        }
    ];

    const schedulerBatchColumnsSm: any[] = [
        {
            fieldName: 'archiveId', caption: t('ID'), width: '10%', key: true, sortable: true,
            redner: (params: any) => (
                <div className="flex-center">
                    <Link className="a-link-black" onClick = {openBatchDetailsView(params)}>
                        {params.archiveId}
                    </Link>
                </div>
            )
        },
        {
            fieldName: 'runStartDate', caption: t('RUN DATE'),width: '45%', sortable: true,
            redner: (params: any) => (
                <div className="flex-center">
                    {params.runStartDate ? formatTimestamp(params.runStartDate) : t('No Run Date')}
                </div>

            )
        },
        {
            fieldName: 'lastRunStatus', caption: t('LAST RUN STATUS'), width: '45%',
            redner: (params: any) => {
                // const _totalRun = (params?.success || 0)+(params?.running || 0)+(params?.failed || 0);
                const _totalRun = (params?.total || 0);
                const s = ((params?.success || 0)/_totalRun) * 100;
                const r = ((params?.running || 0)/_totalRun) * 100;
                const f = ((params?.failed || 0)/_totalRun) * 100;
                const st = ((params?.forceStopped || 0)/_totalRun) * 100;
                const to = ((params?.timeoutStopped || 0)/_totalRun) * 100;
                
                const progress = (params?.success || 0)+(params?.warning|| 0)+(params?.failed || 0)+(params?.forceStopped || 0)+(params?.timeoutStopped || 0);

                return (
                <div className="flex-center">
                    {progress === _totalRun ?
                    <>
                    <div className='bar-container'>
                    <div className='bar-success' title={`${s.toFixed(0)}%`} style={{width:`${s}%`}}></div>
                    <div className='bar-running' title={`${r.toFixed(0)}%`}  style={{width:`${r}%`}}></div>
                    <div className='bar-fail' title={`${f.toFixed(0)}%`}  style={{width:`${f}%`}}></div>
                    <div className='bar-forceStopped' title={`${f.toFixed(0)}%`}  style={{width:`${st}%`}}></div>
                    <div className='bar-timeoutStopped' title={`${to.toFixed(0)}%`}  style={{width:`${to}%`}}></div>
                   </div>
                    <div> 
                        {params?.forceStopped !== 0 && (
                            <span>
                                <BlockIcon  className='forcestop_blockicon'  />
                            </span>
                        )}
                        {params?.timeoutStopped !== 0 && (
                            <span>
                                <BlockIcon  className='timeout_blockicon'  />
                            </span>
                        )}
                        Total: {_totalRun}
                    </div>
                    </>
                    :
                    <>
                    <div className='flex-center w-100' style={{justifyContent: 'space-around'}}>
                    <div>
                        
                        {params?.forceStopped !== 0 && (
                            <span>
                                <BlockIcon  className='forcestop_blockicon' />
                            </span>
                        )}
                        {params?.timeoutStopped !== 0 && (
                            <span>
                                <BlockIcon className='timeout_blockicon' />
                            </span>
                        )}
                        Total: {_totalRun}
                    </div>
                    {/* <div>
                        {params?.stopped  && params?.stopped !== 0 ? t("Running") : t("Stopped")}
                    </div> */}
                    {params?.running !== 0 && (
                        <div><Typography fontWeight={600}>Progress: {progress} / {_totalRun}</Typography></div>
                    )}
                    </div>
                    </>
                    }
                </div>
            )}
        }
    ];

    // Columns for Test Results Status Page
    const testDetailsColumns: any[] = [
        { caption: t('Test Case ID'), width: '55px', fieldName: 'id' },
        { caption: t('Test Case Name'), width: '55px', fieldName: 'name' },
        {
            caption: t('MOS Score'), width: '55px', fieldName: 'mos',
            redner: (params: any) => {
                return `${params.data.testResult.voice.mos}`;
            }
        },
        {
            caption: t('Test Run ID'), width: '55px', fieldName: 'testRunId',
            redner: (params: any) => {
                return `${params.data.testResult.id}`;
            }
        },
        {
            caption: t('From'), width: '55px', fieldName: 'creationTime',
            redner: (params: any) => {
                // return `${formatDate(params.data.testResult?.startTime)} to ${formatDate(params.data.testResult?.endTime)}`;
                return `${formatTimestamp(params.data.testResult?.startTime)} to ${formatTimestamp(params.data.testResult?.endTime)}`;
            }
        },
        {
            caption: t('Duration'), width: '55px', fieldName: 'duration',
            redner: (params: any) => {
                const startTime = new Date(params.data.testResult.startTime);
                const endTime = new Date(params.data.testResult.endTime);
                const durationMilliseconds = endTime.getTime() - startTime.getTime();
                const durationInSeconds = durationMilliseconds / 1000;
                if (durationInSeconds < 0) {
                    return `0 secs`;
                } else {
                    return `${durationInSeconds.toFixed(2)} secs`;
                }
            }
        }
    ];

    const createJiraTicket = ()=> {
        setOpenJiraModal(uniqueId());
    }

    const loadJiraTicket = (params:any)=> async ()=> {
      
        const { data } = await getTestResultDetails(testResultDetails?.testResult?.id, +(project?.testProjectID || projectId || 1), project.data.channelType);
        dispatch(setCurrentTestResultDetails(data));
        history(`/projects/${project?.testProjectID || projectId}/scheduled/testresults/${selectedScheduler?.testScheduleId || scheduledId}/${testResultDetails?.testResult?.id}`);

        if(!params.ignore) {
            createJiraTicket();
        }
    }

    const closeJiraModal = async (saved?:boolean)=> {
        setOpenJiraModal('');

        if(saved) {
            await loadJiraTicket({
                ignore:true,
                id:testResultDetails?.testResult?.id
            })()
        }
    }

    const ScheduleBatchPage = (scheduler: any) => async ()=> {
        const savedSchedulesId = localStorage.getItem("PreviousSchedulesId"); // Retrieve the previous SchedulesId from localStorage
        if (Number(savedSchedulesId) !== scheduler.testScheduleId) { // Convert savedSchedulesId to a number for comparison

        localStorage.removeItem("SchedulesBatchssCurrentPage");
        localStorage.removeItem("SchedulesBatchssitemsPerPage");

        // Update PreviousSchedulesId in localStorage
        localStorage.setItem("PreviousSchedulesId", scheduler.testScheduleId);
    }
        await gotoScheduleBatchPage(scheduler);
    }

    const gotoScheduleBatchPage = async (scheduler: any) => {
        setSelectedScheduler(scheduler);
        setBatchSource('recent');
        setBatchSourceNotice('');

        await fetchBatchList(Number(projectId), scheduler?.testScheduleId || Number(scheduledId) , 'recent');
    

        history(`/projects/${projectId}/scheduled/testresults/${scheduler.testScheduleId}`);
        setSchedulerPage(false);
        setScheduledBatchPage(true);

    }

    const normalizeBatchResponse = (payload: any) => {
        const base = payload?.data ?? payload;

        if (Array.isArray(base)) {
            return { content: base, totalPages: 1 };
        }

        if (Array.isArray(base?.content)) {
            return { content: base.content, totalPages: base.totalPages ?? 1 };
        }

        if (Array.isArray(base?.results)) {
            return { content: base.results, totalPages: base.totalPages ?? 1 };
        }

        if (Array.isArray(payload)) {
            return { content: payload, totalPages: 1 };
        }

        if (Array.isArray(payload?.content)) {
            return { content: payload.content, totalPages: payload.totalPages ?? 1 };
        }

        return { content: [], totalPages: 1 };
    };

    const fetchBatchList = async (projectId : number, scheduleId: number, source: 'recent' | 'all' = batchSource) =>{
        if (!projectId || !scheduleId || Number.isNaN(projectId) || Number.isNaN(scheduleId)) {
            return;
        }

        const pageSize = localStorage.getItem('SchedulesBatchssitemsPerPage') ? localStorage.getItem('SchedulesBatchssitemsPerPage') : criteria.pageSize;
        const pageNo = localStorage.getItem('SchedulesBatchssCurrentPage') ? localStorage.getItem('SchedulesBatchssCurrentPage') : criteria.pageNo;

        if (source === 'all') {
            try {
                const batchListData = await getBatchList(projectId, scheduleId, pageSize, pageNo, project?.data?.channelType);
                const normalized = normalizeBatchResponse(batchListData);
                setBatchList(normalized.content);
                settotalPages(normalized.totalPages || 1);
                setBatchSource('all');
                setBatchSourceNotice('');
            } catch (error) {
                console.error('Failed to load scheduled batch list', error);
                setBatchList([]);
                settotalPages(1);
                setBatchSourceNotice('Unable to load all batches.');
            }
            return;
        }

        let fallbackNotice = '';

        try {
            const recentBatchData = await getRecentBatchList(projectId, scheduleId, pageSize, pageNo, project?.data?.channelType);
            const normalizedRecent = normalizeBatchResponse(recentBatchData);

            if (normalizedRecent.content.length) {
                setBatchList(normalizedRecent.content);
                settotalPages(normalizedRecent.totalPages || 1);
                setBatchSource('recent');
                setBatchSourceNotice('');
                return;
            }

            fallbackNotice = 'No recent batches found. Showing all batches.';
        } catch (error) {
            console.error('Failed to load recent scheduled batches', error);
            fallbackNotice = 'Unable to load recent batches. Showing all batches.';
        }

        setBatchSource('all');

        try {
            const batchListData = await getBatchList(projectId, scheduleId, pageSize, pageNo, project?.data?.channelType);
            const normalized = normalizeBatchResponse(batchListData);
            setBatchList(normalized.content);
            settotalPages(normalized.totalPages || 1);
            setBatchSourceNotice(fallbackNotice);
        } catch (error) {
            console.error('Failed to load scheduled batch list', error);
            setBatchList([]);
            settotalPages(1);
            setBatchSourceNotice(fallbackNotice ? `${fallbackNotice} Unable to load all batches.` : 'Unable to load all batches.');
        }
    }

    const changeBatchSource = async (source: 'recent' | 'all') => {
        const projectIdentifier = toNumber(projectId) ?? toNumber(selectedScheduler?.projectId) ?? toNumber(project?.testProjectID);
        const scheduleIdentifier = toNumber(selectedScheduler?.testScheduleId) ?? toNumber(scheduledId);

        if (projectIdentifier === undefined || scheduleIdentifier === undefined) {
            setBatchSource(source);
            setBatchSourceNotice('');
            setBatchList([]);
            settotalPages(1);
            return;
        }

        setBatchSource(source);
        setBatchSourceNotice('');
        await fetchBatchList(projectIdentifier, scheduleIdentifier, source);
    }

    const openBatchDetailsView = (batch: any) => async () => {
        console.log('batch', batch);
        setDefaultSelected(batch?.archiveId)
        setSelectedBatch(batch);
        setScheduledBatchDetailsPage(true);
    }

    const loadData = async () => {     
       
        const project = await getProjectById(Number(projectId));
        dispatch(setCurrentProject(project));
        dispatch(setCurrentProjectId(projectId));


        const pageSize = localStorage.getItem('SchedulesitemsPerPage') ? localStorage.getItem('SchedulesitemsPerPage') : criteria.pageSize;
        const pageNo = localStorage.getItem('SchedulesCurrentPage') ? localStorage.getItem('SchedulesCurrentPage') : criteria.pageNo;
    
        const { data } = await getScheduleList(Number(projectId), pageSize, pageNo, criteria.filter, project?.data?.channelType);
        if(scheduledId && !testResultId) {
            // Only navigate to batch page if we're not going to a specific test result
            const scheduleData = project?.data?.channelType === CHANNELS.DIGITAL ? data?.content || [] : data?.content || [];
            const findScheduler = scheduleData.find((d: any) => d.testScheduleId === Number(scheduledId));
            await gotoScheduleBatchPage(findScheduler);
        } else if(scheduledId && testResultId) {
            // For direct navigation to test results, we still need to set the selectedScheduler
            // but don't call gotoScheduleBatchPage which would change the URL
            const scheduleData = project?.data?.channelType === CHANNELS.DIGITAL ? data?.content || [] : data?.content || [];
            const findScheduler = scheduleData.find((d: any) => d.testScheduleId === Number(scheduledId));
            setSelectedScheduler(findScheduler);
            if(findScheduler) {
                setBatchSource('recent');
                setBatchSourceNotice('');
                const projectIdentifier = toNumber(projectId) ?? toNumber(findScheduler?.projectId) ?? toNumber(project?.testProjectID);
                const scheduleIdentifier = toNumber(scheduledId) ?? toNumber(findScheduler?.testScheduleId);

                if (projectIdentifier !== undefined && scheduleIdentifier !== undefined) {
                    await fetchBatchList(projectIdentifier, scheduleIdentifier, 'recent');
                }
            }
        }
        setData(data);
        
    };

    const sortChanged = (column: string, direction: string) => {
        if (column === 'startTime') {
            setCriteria({
                ...criteria,
                pageNo: 0,
                sort: `${direction === 'ASC' ? '+' : '-'}startTime`,
            });
        } else {
            setCriteria({
                ...criteria,
                pageNo: 0,
                sort: `${direction === 'ASC' ? '+' : '-'}${column}`,
            });
        }

        setData((previousData: any) => (previousData.content || [])
        .sort((a: any, b: any) => {
            if (direction && criteria.sort) {
                const aValue = a[criteria.sort] || ''; 
                const bValue = b[criteria.sort] || ''; 
                if (direction === 'ASC') {
                    return aValue.localeCompare(bValue);
                } else {
                    return bValue.localeCompare(aValue);
                }
            }
            return 0;
        }));
    };

    // const pageChanged = (page: number, prefix?: string) => {
    //     if (prefix === "Schedules") {
    //     setSchedulerPageNo(page);
    //     } else if (prefix === "SchedulesBatchss") {
    //     setScheduledBatchPageNo(page);
    //     }
    //     setCriteria({
    //         ...criteria,
    //         pageNo: page - 1,
    //     })
    // }

    const pageChanged = (page: number, prefix?: string) => {
        const normalizedPrefix = prefix?.toLowerCase();

        if (normalizedPrefix === "schedules") {
            setSchedulerPageNo(page);
            setCriteria((prevCriteria: typeof criteria) => ({
                ...prevCriteria,
                pageNo: page - 1,
            }));
            return;
        }

        if (normalizedPrefix === "schedulesbatchss") {
            setScheduledBatchPageNo(page);
            setCriteria((prevCriteria: typeof criteria) => ({
                ...prevCriteria,
                pageNo: page - 1,
            }));
            return;
        }

        // Fallback for general page changes
        setCriteria((prevCriteria: typeof criteria) => ({
            ...prevCriteria,
            pageNo: page - 1,
        }));
    };

    const selectionChanged = (id: any) => {
        setSelectedBatchIds(id);
    }

    const onFilterChanged = (filter: string) => {
       localStorage.setItem('SchedulesFilter', filter);
        setSchedulerPageNo(0);
        setCriteria({
            ...criteria,
            pageNo: 0,
            filter,
        })
    }

    useEffect(()=> {
       loadData();
    },[criteria]);

    // Handle direct navigation based on URL parameters
    useEffect(() => {
        const handleDirectNavigation = async () => {
            if (testResultId && scheduledId) {
                // Ensure we have project data loaded first
                let currentProject = project;
                if (!currentProject) {
                    const projectData = await getProjectById(Number(projectId));
                    dispatch(setCurrentProject(projectData));
                    dispatch(setCurrentProjectId(projectId));
                    currentProject = projectData;
                }
                
                // Load test result details first, then set page state
                try {
                    const { data } = await getTestResultDetails(Number(testResultId), Number(projectId), currentProject?.data?.channelType);
                    dispatch(setCurrentTestResultDetails(data));
                    
                    // Only set the page state after data is successfully loaded
                    setSchedulerPage(false);
                    setScheduledBatchPage(false);
                    setScheduledBatchDetailsPage(false);
                    setScheduledTestResultDetailsPage(true);
                } catch (error) {
                    console.error('Error loading test result details for direct navigation:', error);
                    // Don't change page state if data loading fails
                }
                
            } else if (scheduledId && !testResultId) {
                // Direct navigation to scheduled batch page - existing logic handles this in loadData
                // The existing logic in loadData() already handles this case properly
            }
            // If only projectId, stay on scheduler page (default behavior)
        };

        // Only run this on initial mount and when URL parameters change
        if (projectId && testResultId && scheduledId) {
            handleDirectNavigation();
        }
    }, [projectId, scheduledId, testResultId, project, dispatch]); // Include dependencies

    const closeBatchDetails = () => {
        setDefaultSelected('');
        setSelectedBatch(null);
        setScheduledBatchDetailsPage(false);
    }

    const openCompareBatchModal = () => {
        if(selectedBatchIds.length !== 2) {
            dispatch(toggleAlert(t("Select 2 Batches to compare")));
            return;
        }

        const firstBatch = batchList.find((batch : any) => +batch.archiveId === +selectedBatchIds[0]);
        const secondBatch = batchList.find((batch : any) => +batch.archiveId === +selectedBatchIds[1]);
        if(firstBatch?.running !== 0 || secondBatch?.running !== 0) {
            dispatch(toggleAlert(t("Running batch can't be compared")));
            return;
        }

        setOpenCompareBatch(uniqueId());
    }

    const closeCompareBatchModal = () => {
        setOpenCompareBatch('');
    }

    const openSchedulerPage = () => {
        // setScheduledBatchPage(false);
        // setScheduledBatchDetailsPage(false);
        // setScheduledTestResultDetailsPage(false);
        // setSchedulerPage(true);
        // loadData();
        // history(`/projects/${project?.testProjectID || projectId}/scheduled/testresults`);
        window.location.replace(`/projects/${project?.testProjectID || projectId}/scheduled/testresults`);

    }

    const openScheduleBatchPage = () => {
        setSchedulerPage(false);
        setScheduledTestResultDetailsPage(false);
        // setScheduledBatchDetailsPage(false);
        setScheduledBatchPage(true);
        setScheduledBatchDetailsPage(true);
        history(`/projects/${selectedScheduler.projectId || projectId}/scheduled/testresults/${selectedScheduler.testScheduleId || scheduledId ? scheduledId : 0}`);
    }

    const openTestResultsDetailsView = () => {
        setScheduledBatchPage(false);
        setScheduledBatchDetailsPage(false);
        setSchedulerPage(false);
        setOpenCompareBatch('');
        setScheduledTestResultDetailsPage(true);
    }

    const deleteSelected  =  async () => {
        if(selectedBatchIds.length) {
            setIsOpen(`${new Date().getTime()}`);
        }
       
    }

    const deleteBatches = async () => {
        // await deleteTestResults(project.testProjectID, selectedBatchIds);
        await deleteSelectedBatches(project.testProjectID, selectedScheduler?.testScheduleId || scheduledId, selectedBatchIds);
        window.location.reload();
        // await fetchBatchList(selectedScheduler?.projectId, selectedScheduler?.testScheduleId);
        // setSelectedBatchIds([]);
    }

    const reloadBatchList = async () => {
        const projectIdentifier = toNumber(selectedScheduler?.projectId) ?? toNumber(projectId) ?? toNumber(project?.testProjectID);
        const scheduleIdentifier = toNumber(selectedScheduler?.testScheduleId) ?? toNumber(scheduledId);

        if (projectIdentifier !== undefined && scheduleIdentifier !== undefined) {
            await fetchBatchList(projectIdentifier, scheduleIdentifier, batchSource);
        }
    }

    const formatDate = (dateTimeString: any) => {
        if (!dateTimeString) return '';

        const date = new Date(dateTimeString);
        const formattedDate = `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}`;
        return formattedDate;
    };

    useEffect(() => {
        loadData();
    }, [])

    const handleStopTestRun = async () => {
        console.log('testResultId', testResultDetails?.testResult?.id);
        const { data } = await testRunStop(testResultDetails?.testResult?.id);
        if(data) {
            dispatch(toggleAlert('Test run stopped successfully.'));
        }
        window.location.reload();
    }

        const exportlogFile = (id: any) => async () => {
            try {
                const { data } = await getexportlogFile(id); // Fetch the log data
                exportToFile(data, `log_${id}.txt`, 'text/plain'); // Use the helper function
            } catch (error) {
                console.error('Error exporting log file:', error);
            }
        };

        const exportLensLogFile = (id: any) => async () => {
            try {
                const { data } = await getLensLogFile(id, project?.data?.channelType); // Fetch the Lens log data
                exportToFile(data, `lens_log_${id}.txt`, 'text/plain');
            } catch (error) {
                console.error('Error exporting Lens log file:', error);
            }
        };

    let gridItemSize = (scheduledBatchDetailsPage && selectedBatch) ? 6 : 12;
    const hasSelectedSchedule = Boolean(selectedScheduler?.testScheduleId || scheduledId);

    return (
        <DndProvider backend={HTML5Backend}>
            <Grid container>
                {/* Header */}
                <Grid item xs={12} paddingTop={'16px'} paddingBottom={'10px'}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', height: '100%' }}>
                        <Typography variant="subtitle2">{t('Project')} :</Typography>
                        <Typography variant="subtitle2">{project ? project?.testProjectID : projectId}</Typography>
                        {/* {project?.data?.channelType === CHANNELS.VOICE ? (<PhoneEnabledOutlinedIcon style={{ fontSize: '17px' }} />) : (<img src={digital} alt="" width={17}/>)} */}
                        {project ?
                            <>
                                <Typography variant="subtitle2">
                                    <Link
                                        onClick={openSchedulerPage}
                                        className="a-link-black"
                                    >
                                        {project?.data?.name}
                                    </Link>
                                </Typography>
                            </>
                            : null}
                            <Typography variant="subtitle2">{'>'}</Typography>
                            <Typography variant="subtitle2">
                                <Link
                                    onClick={openSchedulerPage}
                                    className="a-link-black"
                                >
                                    {t('Scheduled Test Runs')}
                                </Link>
                            </Typography>
                        {(scheduledBatchPage) && (<>
                            <Typography variant="subtitle2">{'>'}</Typography>
                            <Typography variant="subtitle2">
                                {selectedScheduler?.name}
                            </Typography>
                            </>
                        )}

                        {scheduledTestResultDetailsPage && (
                            <>
                            <Typography variant="subtitle2">{'>'}</Typography>
                            <Typography variant="subtitle2">
                                <Link
                                    onClick={openScheduleBatchPage}
                                    className="a-link-black">
                                    {selectedScheduler?.name}
                                </Link>                            
                            </Typography>
                            <Typography variant="subtitle2">{'>'}</Typography>
                            <Typography variant="subtitle2">
                                {testResultDetails?.name} 
                            </Typography>
                            </>
                        )}
                         {/* {scheduledTestResultDetailsPage &&
                         <Button  variant="outlined" color="info" onClick={exportlogFile(testResultDetails?.testResult?.id)} >FS LOGS</Button>
                        } */}
                        {scheduledTestResultDetailsPage &&
                         <Button  variant="outlined" color="info" style={{ marginLeft: '8px' }} onClick={exportLensLogFile(testResultDetails?.testResult?.id)} >LENS LOGS</Button>
                        }
                        {hasJiraEnabled && scheduledTestResultDetailsPage &&
                            <div className='sh-jira'>
                                    {testResultDetails?.testResult?.jiraTicket ? <div onClick={createJiraTicket} className='jira-ticket-link justify-end'><img src={hasJiraIcon} alt=""/> {t('Check Jira Status')}</div> : <div onClick={createJiraTicket} className='jira-ticket-link justify-end'><AddCircleOutlineIcon className="blue-icon"/> {t('Create a Jira Ticket')}</div>}
                            </div>  
                        }
                         {testResultDetails?.testResult?.status === 'RUNNING' ? <Button variant="outlined" color="error" style={{ marginRight: "10px" }} onClick={handleStopTestRun}> FORCE STOP </Button> : "" }
                         
                    </div>
                
                   
                </Grid>
              

                {/* Case Editor or DataGrid */}
                {schedulerPage && (
                    <Grid item xs={gridItemSize} paddingRight={'9px'}>
                        <div>
                            <Card>
                                <CardContent>
                                <div className='test-result-header'>
                                        <div className="action-header">
                                        </div>
                                        <div className="test-results-filters">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => history(`/projects/${project?.testProjectID || projectId}/scheduler`)}
                                            >
                                                {t('Scheduler')}
                                        </Button>
                                            <SearchInput onFilter={onFilterChanged} defaultValue={criteria.filter}/>
                                        </div>
                                    </div>
                                    <SchedulerGrid
                                        totalPages={data?.totalPages || 0}
                                        sortChanged={sortChanged}
                                        columns={schedulerColumns}
                                        data={project?.data?.channelType === CHANNELS.DIGITAL ? data?.content || [] : data?.content || []}
                                        sortBy={criteria.sort}
                                        storageKeyPrefix={'Schedules'}
                                        selectionChanged={selectionChanged} 
                                        pageChanged={pageChanged}
                                        pageSizeChanged={pageSizeChanged}/>
                                </CardContent>
                            </Card>
                        </div>
                        
                    </Grid>
                )}
                {scheduledBatchPage && (
                    <Grid item xs={gridItemSize} paddingRight={'9px'}>
                        <div>
                            <Card>
                                <CardContent>
                                    <div className='test-result-header'>
                                        <div className="action-header">
                                            {/* <Link onClick={deleteBatches}> */}
                                            <Link onClick={deleteSelected}>
                                                <img src={deleteIcon} alt={t('Remove')} />
                                            </Link>                                                                                        
                                            <img src={scheduledBatchExportIcon} alt={t('Export')} />
                                            <Link onClick={openCompareBatchModal}>
                                                <img src={scheduledBatchCompareIcon} alt={t('Compare')} />
                                            </Link>
                                            
                                        </div>
                                        <div className="test-results-filters">
                                            <ToggleButtonGroup
                                                value={batchSource}
                                                exclusive
                                                size="small"
                                                onChange={(event, value) => {
                                                    if (value) {
                                                        changeBatchSource(value as 'recent' | 'all');
                                                    }
                                                }}
                                            >
                                                <ToggleButton value="recent" disabled={!hasSelectedSchedule}>
                                                    {t('Recent Batches')}
                                                </ToggleButton>
                                                <ToggleButton value="all" disabled={!hasSelectedSchedule}>
                                                    {t('All Batches')}
                                                </ToggleButton>
                                            </ToggleButtonGroup>
                                        </div>
                                    </div>
                                    {batchSourceNotice && (
                                        <Typography variant="caption" color="text.secondary" style={{ display: 'block', marginTop: '8px' }}>
                                            {batchSourceNotice}
                                        </Typography>
                                    )}
                                    <SchedulerGrid
                                        pageChanged={pageChanged}
                                        defaultSelected={defaultSelected}
                                        totalPages={totalPages || 0}
                                        sortChanged={sortChanged}
                                        columns={(scheduledBatchDetailsPage && selectedBatch) ? schedulerBatchColumnsSm : schedulerBatchColumns}
                                        data={batchList}
                                        selection={true}
                                        sortBy={criteria.sort}
                                        storageKeyPrefix={'SchedulesBatchss'}
                                        selectionChanged={selectionChanged} 
                                        pageSizeChanged={pageSizeChanged}/>
                                </CardContent>
                            </Card>
                        </div>
                        
                    </Grid>
                )}
                {(scheduledBatchDetailsPage && selectedBatch) && (
                    <Grid item xs={6} paddingRight={'9px'} style={{}}>
                        <BatchDetails 
                        showCloseButton={true} 
                        closeBatchDetails={closeBatchDetails} 
                        projectId={projectId} 
                        testcaseId={1551} 
                        selectedBatch={selectedBatch}
                        openTestResultsDetailsView={openTestResultsDetailsView}
                        reloadBatchList={reloadBatchList} />
                    </Grid>
                    
                )}

                {scheduledTestResultDetailsPage && (
                    <Grid item xs={12}>
                        <TestResultDetails
                            pageChanged={pageChanged}
                            totalPages={data?.totalPages || 0}
                            sortChanged={sortChanged}
                            columns={testDetailsColumns}
                            data={
                                testResultDetails || []
                            }
                            selection={true}
                            sortBy={criteria.sort}
                            selectionChanged={selectionChanged}
                            formatDate={formatDate}
                            onFilterChanged={onFilterChanged}
                            criteria={criteria}
                        />
                    </Grid>
                )}

                <Modal 
                    isOpen={openCompareBatch}
                    big={true}
                    body={
                    <CompareBatches
                        projectId={projectId}
                        closeCompareBatch={closeCompareBatchModal} 
                        firstbatch={batchList.find((batch : any) => +batch.archiveId === +selectedBatchIds[0])} 
                        secondBatch={batchList.find((batch : any) => +batch.archiveId === +selectedBatchIds[1])}
                        openTestResultsDetailsView={openTestResultsDetailsView}
                        reloadBatchList={reloadBatchList}
                    />
                    }                    
                />
            </Grid>

              <Modal
                    isOpen={isOpen}
                    title={t("Delete Items")}
                    small={true}
                    deleteConfirmation={true}
                    ButtonDelete={deleteBatches}
                />

             <Modal
                    isOpen={openJiraModal}
                    className={'full-width'}
                    title={testResultDetails?.testResult?.jiraTicket ? t("Modify Jira Ticket"):t("Create a Jira Ticket")}
                    body={<JiraTicket scheduled={selectedScheduler?.testScheduleId || scheduledId} testResultDetails={testResultDetails} project={project}  
                        cancel={closeJiraModal} channel={project?.data?.channelType}/>}
                />
        </DndProvider>

    );
};